import { loadBackgrounds, setBGLoaded, setError } from 'store';
import { CachedSprites, fetchImage } from 'lib/utils';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { BackgroundResponse } from 'components/BackgroundComponent/types';

const useBackgroundLoad = () => {
  const dispatch = useDispatch();
  const [spritesList, setSpritesList] = useState<CachedSprites>([]);

  const loadSetting = useCallback(async () => {
    try {
      const action: any = await dispatch(loadBackgrounds());
      if (action.error) {
        return;
      }
      const loadBACKS = await Promise.allSettled(
        action.payload.map(({ id, url }: BackgroundResponse) => fetchImage(id, url))
      );
      let load = true;
      const saveBackground = loadBACKS.reduce((a, b) => {
        if (b.status !== 'fulfilled') {
          load = false;
        } else {
          return { ...a, ...(b.value || {}) };
        }
        return a;
      }, {});
      dispatch(setBGLoaded(load));
      if (load) {
        setSpritesList(saveBackground as any);
      }
    } catch {
      dispatch(setError());
    }
  }, []);

  useEffect(() => {
    loadSetting();
  }, [loadSetting]);

  return spritesList;
};

export default useBackgroundLoad;
